/**
 * This file reads the env variables and sets defaults to the optional ones.
 * It exports an object containing the values of all the read env variables
 */

let languages = ["en"];
if (typeof process.env.VUE_APP_LANGUAGES !== "undefined") {
  languages = process.env.VUE_APP_LANGUAGES.split(",");
}

let apiVersion = "v1";
if (typeof process.env.VUE_APP_API_VERSION !== "undefined") {
  apiVersion = process.env.VUE_APP_API_VERSION;
}

export default {
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  skitudeApi: {
    baseUrl: process.env.VUE_APP_SKITUDEAPI_BASE_URL,
    xApiKey: process.env.VUE_APP_SKITUDEAPI_X_API_KEY,
  },
  languages,
  apiVersion,
  apiToken: undefined
};
